<script>
import FieldInput from './FieldInput.vue';

/* global $ */

const dadataUri = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs';
const dadataToken = '5a585e2ee3e58599595d913c1c702ddf232276db';

export default {
    name: "FieldSuggests",
    extends: FieldInput,
    props: {
        dataType: String,
        maxCount: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            suggestionsInstance: null
        }
    },
    computed: {
        dadataType() {
            if (this.dataType === 'address') {
                return 'ADDRESS';
            } else if (this.dataType === 'inn') {
                return 'PARTY';
            } else if (this.dataType === 'bank') {
                return 'BANK';
            }
            return null;
        },
        options() {
            let options = {
                serviceUrl: dadataUri,
                token: dadataToken,
                type: this.dadataType,
                count: this.maxCount,
                scrollOnFocus: false,
                floating: false,
                triggerSelectOnBlur: false,
                onSelect: this.onSelectSuggest
            }

            if (this.dataType === 'inn' || this.dataType === 'bank') {
                options.formatResult = this.formatResult;
                options.formatSelected = this.formatSelected;
            }

            if (this.dataType === 'address') {
                options.formatSelected = this.formatSelected;
            }

            return options
        }
    },
    watch: {
        options() {
            this.initSuggestions()
        }
    },
    beforeDestroy() {
        this.destroySuggestions()
    },
    mounted() {
        this.initSuggestions()
    },
    methods: {
        initSuggestions() {
            if (this.suggestionsInstance === null) {
                this.suggestionsInstance = $(this.$el).find('input').suggestions(this.options).suggestions();
            } else {
                this.suggestionsInstance.setOptions(this.options);
            }
        },
        destroySuggestions() {
            if (this.suggestionsInstance !== null) {
                this.suggestionsInstance.dispose();
            }
        },
        onSelectSuggest(suggestion) {
            if (suggestion) {
                this.$emit('select', suggestion.data);
            }
        },
        formatResult(value, currentValue, suggestion) {
            let result = '';
            if (suggestion.data) {
                if (this.dataType === 'inn') {
                    if (suggestion.data.name) {
                        result = suggestion.data.name.short_with_opf
                    }
                    if (suggestion.data.inn && suggestion.data.address) {
                        result += '<br><small>' + suggestion.data.inn + ', ' + suggestion.data.address.value + '</small>'
                    }
                    suggestion.value = suggestion.data.inn;
                } else if (this.dataType === 'bank') {
                    if (suggestion.data.name) {
                        result = suggestion.data.name.payment
                    }
                    if (suggestion.data.bic && suggestion.data.address) {
                        result += '<br><small>' + suggestion.data.bic + ', ' + suggestion.data.address.value + '</small>'
                    }
                    suggestion.value = suggestion.data.bic;
                }
            }
            return result
        },
        formatSelected(suggestion) {
            let result = '';
            if (suggestion.data) {
                if (this.dataType === 'inn') {
                    result = suggestion.data.inn;
                } else if (this.dataType === 'bank') {
                    result = suggestion.data.bic;
                } else if (this.dataType === 'address') {
                    result = this.value;
                }
            }
            return result
        }
    }
}
</script>

<style scoped>

</style>